import React from 'react';

export default function Logo({ brand, alt, file = 'logo-login.png' }) {
  return <img className="mb-0" src={`${process.env.PUBLIC_URL}/img/${brand}/${file}`} alt={alt} />;
}
